import React, { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaRupeeSign,
} from "react-icons/fa";
import "./LocationDetails.css";
import { Link, useParams } from "react-router-dom";
import Header from "../Header";
import host from "../../config";

const MGMLawns = () => {
  const { id } = useParams();
  const [ImagesList, setImagesList] = useState([]);
  console.log(useParams());
  useEffect(() => {
    if (!id) return; // Prevent running if ID is not available

    fetch(`${host}/get-booking-images-by-id`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }), // Correct JSON structure
    })
      .then((response) => response.json())
      .then((res) => {
        setImagesList(res);
        console.log("Fetched Images:", res);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [id]); // Only depends on id

  // const images = [
  //   "/images/mgm.jpeg",
  //   "/images/mgm2.jpg",
  // ];
  const pricingData = [
    {
      id: 1,
      name: "MGM Lawn 1",
      purpose:
        "Birthday Functions & Other Official/ Corporate Meetings/ Get-together/Marriage/ Engagements/ Receptions.(General Meetings)",
      rent: 50000,
      deposit: 20000,
      gst: 10350,
      cleaningCharges: 7500,
      total: 87850,
    },
    {
      id: 2,
      name: "MGM Lawn 2",
      purpose:
        "Birthday Functions & Other Official/ Corporate Meetings/ Get-together/Marriage/ Engagements/ Receptions.(General Meetings)",
      rent: 25000,
      deposit: 10000,
      gst: 495,
      cleaningCharges: 2500,
      total: 42450,
    },
    {
      id: 3,
      name: "MGM Lawn 3",
      purpose:
        "Birthday Functions & Other Official/ Corporate Meetings/ Get-together/Marriage/ Engagements/ Receptions.(General Meetings)",
      rent: 25000,
      deposit: 10000,
      gst: 4950,
      cleaningCharges: 2500,
      total: 42450,
    },
  ];

  return (
    <div>
      <Header />
      <div className="location-page">
        <div className="hero">
          <Carousel showThumbs={false} autoPlay interval={3000} infiniteLoop>
            {ImagesList.map((item, idx) => (
              <div key={idx} className="carousel-image">
                <img src={item.url} alt={`MGM Lawns Image ${idx + 1}`} />
                <div className="overlay">
                  <h1>MGM Lawns</h1>
                  <p>Premium Event Space in Vizag</p>
                </div>
              </div>
            ))}
          </Carousel>
        </div>

        <div className="location-details">
          <h2>About the Venue</h2>
          <p className="line-height">
            <strong>MGM Lawns</strong>, situated in{" "}
            <strong>Visakhapatnam</strong>, is an elegant venue ideal for a
            variety of events, including{" "}
            <strong>
              corporate gatherings, weddings, school functions, and private
              celebrations
            </strong>
            . It offers spacious open lawns, modern amenities, and an
            air-conditioned auditorium.
          </p>

          <h3>Key Amenities</h3>
          <ul className="amenities-list">
            <li>✅ Expansive Open Lawn</li>
            <li>✅ Fully Air-conditioned Auditorium</li>
            <li>✅ High-quality Sound & Lighting System</li>
            <li>✅ Ample Parking Space</li>
            <li>✅ Dedicated Green Rooms & Dressing Areas</li>
          </ul>

          <h3>📌 Venue Pricing Details</h3>
          <div className="pricing-container">
            {pricingData.map((item) => (
              <div key={item.id} className="pricing-section">
                <h2 className="lawn-title">{item.name}</h2>
                <div className="pricing-card">
                  <h4>{item.purpose}</h4>
                  <p>
                    <FaRupeeSign /> Rent per Day:{" "}
                    <strong>{item.rent.toLocaleString()}</strong>
                  </p>
                  <p>
                    <FaRupeeSign /> Security Deposit:{" "}
                    <strong>{item.deposit.toLocaleString()}</strong>
                  </p>
                  <p>
                    <FaRupeeSign /> GST (18%):{" "}
                    <strong>{item.gst.toLocaleString()}</strong>
                  </p>
                  <p>
                    <FaRupeeSign /> Cleaning Charges:{" "}
                    <strong>{item.cleaningCharges.toLocaleString()}</strong>
                  </p>
                  <p className="total">
                    <FaRupeeSign />{" "}
                    <strong>Total: {item.total.toLocaleString()}</strong>
                  </p>
                </div>
              </div>
            ))}
          </div>

          <p className="note">
            <strong>Note:</strong> Electrical charges as consumed and sweeping
            charges of ₹2,000 + GST (18%) will be paid by the applicant to
            VMRDA.
          </p>

          <h3>📞 Contact Information</h3>
          <div className="contact-info">
            <p>
              <FaMapMarkerAlt /> Location: Visakhapatnam
            </p>
            <p>
              <FaPhoneAlt /> Phone: +91 98765 43210
            </p>
            <p>
              <FaEnvelope /> Email: info@mgmlawns.com
            </p>
          </div>

          <Link to="/" className="book-now-btn">
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MGMLawns;
